import { graphql } from '@/client/services/api/graphql/gql';

export const updateUserDashboardHeroImageMutation = graphql(`
  mutation UpdateUserDashboardHeroImage($id: String!, $update: UserUpdateInput!) {
    updateUser(id: $id, update: $update) {
      id
    }
  }
`);
